/**
 * Where the consumer session token is persisted between reloads. The single
 * `4f:token` key the whole surface keys off — `CompanionSurface` unlocks the API
 * client + `/ws` the moment it is present. Distinct from the console's
 * `4f:staff-token`: the two realms never mix. Reads/writes are guarded so a
 * disabled/absent `localStorage` (private mode, SSR, quota) degrades to "no
 * stored token" instead of throwing. Pure + testable.
 */

/** The localStorage key holding the consumer access token. */
export const SESSION_TOKEN_KEY = '4f:token';

/** Read the persisted session token, or `null` when absent/unavailable. */
export function loadStoredToken(): string | null {
  try {
    return globalThis.localStorage?.getItem(SESSION_TOKEN_KEY) ?? null;
  } catch {
    return null;
  }
}

/** Persist the session token, or clear it when `null`. Never throws. */
export function storeToken(token: string | null): void {
  try {
    if (token === null) {
      globalThis.localStorage?.removeItem(SESSION_TOKEN_KEY);
    } else {
      globalThis.localStorage?.setItem(SESSION_TOKEN_KEY, token);
    }
  } catch {
    // A write failure (quota, private mode) must not break auth — the in-memory
    // token still drives the session for this tab.
  }
}
